import { filter, first, isEmpty } from 'lodash'
import { PERMISSION_COLUMNS } from 'pages/Administration/components/Table/configs'
import { frameworkComponents } from 'pages/Administration/constants'

export const outputColumns = (t) => [
  {
    checkboxSelection: true,
    headerName: t('RolesManagement.RolesColumn.Name'),
    headerTooltip: t('RolesManagement.RolesColumn.Name'),
    field: 'roleName',
    colId: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: 'agGroupCellRenderer',
    cellClass: 'group-link'
  }
]

export const detailCellRendererParams = (t, getLabel) => {
  const { read /*, create, update, deletion, execute */ } =
    PERMISSION_COLUMNS(t)
  const disabled = true

  return {
    detailGridOptions: {
      suppressContextMenu: true,
      columnDefs: [
        {
          headerName: t('OutputManagement.Page'),
          headerTooltip: t('OutputManagement.Page'),
          field: 'outputField',
          colId: 'outputField',
          filter: 'agTextColumnFilter',
          cellRenderer: ({ data }) => {
            return getLabel(data?.outputField)
          }
        },
        read(disabled, true)
        // create(disabled, true),
        // update(disabled, true),
        // deletion(disabled, true),
        // execute(disabled, true)
      ],
      frameworkComponents,
      defaultColDef: {
        autoSizeColumnsOnFirstRender: true,
        flex: 1
      }
    },
    getDetailRowData: ({ data: { permissions }, successCallback }) => {
      successCallback(permissions)
    }
  }
}
